import { supabase } from '../lib/supabase';

export const nfcService = {
  getNfcLink: async (cardId, userId) => {
    const { data, error } = await supabase
      .from('card_nfc_links')
      .select('*, cards(internal_name, public_slug, status)')
      .eq('card_id', cardId)
      .eq('user_id', userId)
      .single();

    if (error && error.code !== 'PGRST116') throw error;
    return data || null;
  },

  createNfcLink: async (cardId, userId) => {
    // Generate a long, secure token
    const token = Math.random().toString(36).substring(2, 15) + 
                 Math.random().toString(36).substring(2, 15) + 
                 Date.now().toString(36);

    const { data, error } = await supabase
      .from('card_nfc_links')
      .insert({
        card_id: cardId,
        user_id: userId,
        token: token,
        status: 'active'
      })
      .select('*, cards(internal_name, public_slug, status)')
      .single();

    if (error) throw error;
    return data;
  },

  updateStatus: async (nfcId, userId, newStatus) => {
    const { data, error } = await supabase
      .from('card_nfc_links')
      .update({ status: newStatus })
      .eq('id', nfcId)
      .eq('user_id', userId)
      .select('*, cards(internal_name, public_slug, status)')
      .single();

    if (error) throw error;
    return data;
  },

  reassignCard: async (nfcId, userId, newCardId) => {
    const { data, error } = await supabase
      .from('card_nfc_links')
      .update({ card_id: newCardId })
      .eq('id', nfcId)
      .eq('user_id', userId)
      .select('*, cards(internal_name, public_slug, status)')
      .single();

    if (error) throw error;
    return data;
  },

  regenerateToken: async (nfcId, userId) => {
    const token = Math.random().toString(36).substring(2, 15) + 
                 Math.random().toString(36).substring(2, 15) + 
                 Date.now().toString(36);

    const { data, error } = await supabase
      .from('card_nfc_links')
      .update({ token: token })
      .eq('id', nfcId)
      .eq('user_id', userId)
      .select('*, cards(internal_name, public_slug, status)')
      .single();

    if (error) throw error;
    return data;
  },

  resolveToken: async (token) => {
    const { data, error } = await supabase.rpc('resolve_nfc_token', { p_token: token });
    if (error) throw error;
    return data && data.length > 0 ? data[0].slug : null;
  }
};